import { render } from "./OnboardingNotificationPage.vue?vue&type=template&id=7d2119c1&ts=true"
import script from "./OnboardingNotificationPage.vue?vue&type=script&lang=ts"
export * from "./OnboardingNotificationPage.vue?vue&type=script&lang=ts"

import "./OnboardingNotificationPage.vue?vue&type=style&index=0&id=7d2119c1&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__